import { useState, useEffect } from 'react';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

interface PlatformSettings {
  site_name?: string;
  site_url?: string;
  logo_url?: string;
  logo_text?: string;
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string;
  seo_og_image?: string;
  favicon_url?: string;
  google_analytics_id?: string;
  google_tag_manager_id?: string;
  facebook_pixel_id?: string;
  tiktok_pixel_id?: string;
  // SEO/AEO fields added in migration 023. All optional — fall back
  // to platform defaults baked into client/index.html when missing.
  organization_name?: string;
  organization_logo_url?: string;
  organization_same_as?: string[];
  twitter_handle?: string;
  default_author_name?: string;
  default_author_bio?: string;
  blog_enabled?: boolean;
  ai_indexing_enabled?: boolean;
}

/**
 * Hook to load platform-wide settings (for main domain only)
 * Fetches publicly available settings without authentication
 */
export const usePlatformSettings = () => {
  const [settings, setSettings] = useState<PlatformSettings>({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/public/platform-settings`);
        
        if (response.ok) {
          const data = await response.json();
          setSettings(data);
        }
      } catch (error) {
        console.error('Failed to load platform settings:', error);
        // Fail silently - analytics are optional
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, isLoading };
};

